import Parse from "parse";

import type { Stop } from "./Stop";
import type { Trip } from "./Trip";

type OD3_Tenant = Parse.Object;

export interface Stop_TimesAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  arrival_time?: Date;
  departure_time?: Date;
  stop_id: Stop;
  stop_sequence: number;
  tenant: OD3_Tenant;
  trip_id: Trip;
}

export class Stop_Times extends Parse.Object<Stop_TimesAttributes> {
  static className: string = "OD3_GTFS_Stop_Times";

  constructor(data?: Partial<Stop_TimesAttributes>) {
    super("OD3_GTFS_Stop_Times", data as Stop_TimesAttributes);
  }

  get arrival_time(): Date | undefined {
    return super.get("arrival_time");
  }
  set arrival_time(value: Date | undefined) {
    super.set("arrival_time", value);
  }
  get departure_time(): Date | undefined {
    return super.get("departure_time");
  }
  set departure_time(value: Date | undefined) {
    super.set("departure_time", value);
  }
  get stop_id(): Stop {
    return super.get("stop_id");
  }
  set stop_id(value: Stop) {
    super.set("stop_id", value);
  }
  get stop_sequence(): number {
    return super.get("stop_sequence");
  }
  set stop_sequence(value: number) {
    super.set("stop_sequence", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
  get trip_id(): Trip {
    return super.get("trip_id");
  }
  set trip_id(value: Trip) {
    super.set("trip_id", value);
  }
}

Parse.Object.registerSubclass("OD3_GTFS_Stop_Times", Stop_Times);
